// extracted by mini-css-extract-plugin
export default {"buttonContainer":"ListaAziende_buttonContainer__78Pz+","title":"ListaAziende_title__Rc51n"};